import {
    NAVIGATE_NEXT,
    NAVIGATE_PREVIOUS,
    navigateToGetQuote,
    navigateToPersonalDetails,
    navigateToBeneficiaries,
    navigateToNextOfKin,
    navigateToPayment,
} from '../../../actions/personalPensionPlan/routing';
import { getActivePageIndex } from '../../../selectors/personalPensionPlan/routing';
import { PAGE_INDICES } from '../../../actions/personalPensionPlan/types';
import { apiTransitionBeneficiariesForm } from '../../../actions/personalPensionPlan/beneficiaries';
import { apiTransitionNextOfKinForm } from '../../../actions/personalPensionPlan/nextOfKin';
import { apiTransitionPersonalDetailsForm } from '../../../actions/personalPensionPlan/personalDetails';

export const routingRules = (store, next, action) => {
    if (action.type !== NAVIGATE_NEXT && action.type !== NAVIGATE_PREVIOUS) return next(action);
    const result = next(action);
    const state = store.getState();
    const activePageIndex = getActivePageIndex(state);
    if (action.type === NAVIGATE_NEXT) {
        onNavigateNext(store, state, activePageIndex);
        return result;
    }
    onNavigatePrevious(store, state, activePageIndex);
    return result;
};

const onNavigateNext = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.QUOTE:
            store.dispatch(navigateToPersonalDetails());
            break;

        case PAGE_INDICES.PERSONAL_DETAILS:
            store.dispatch(navigateToNextOfKin());
            break;

        case PAGE_INDICES.NEXT_OF_KIN:
            store.dispatch(navigateToBeneficiaries());
            break;

        case PAGE_INDICES.BENEFICIARIES:
            store.dispatch(navigateToPayment());
            break;

        default:
            store.dispatch(navigateToGetQuote());
            break;
    }
};

const onNavigatePrevious = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.PERSONAL_DETAILS:
            store.dispatch(navigateToGetQuote());
            break;

        case PAGE_INDICES.NEXT_OF_KIN:
            store.dispatch(apiTransitionPersonalDetailsForm.initial());
            store.dispatch(navigateToPersonalDetails());
            break;

        case PAGE_INDICES.BENEFICIARIES:
            store.dispatch(apiTransitionNextOfKinForm.initial());
            store.dispatch(navigateToNextOfKin());
            break;

        case PAGE_INDICES.PAYMENT:
            store.dispatch(apiTransitionBeneficiariesForm.initial());
            store.dispatch(navigateToBeneficiaries());
            break;

        default:
            store.dispatch(navigateToGetQuote());
            break;
    }
};
